<template>
  <!--
      作者 kmdshop
      时间：2020-06-09
      描述：会员-等级管理-添加商品
  -->
   <div>
  <el-dialog title="添加商品" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false" width="600px">
    <el-form size="small" :model="form" ref="form">
      <el-form-item :label-width="formLabelWidth" label="状态">
        <el-radio-group v-model="form.status">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item>



      <el-form-item :label-width="formLabelWidth" label="选择商品">
        <RelationProduct :form="form" ></RelationProduct>
      </el-form-item>



      <el-form-item :label-width="formLabelWidth" label="设置返利">
        <el-table size="small" :data="gradeList" border>
          <el-table-column prop="name" label="用户等级"></el-table-column>
          <el-table-column prop="first_rebate" label="第一单/%">
            <template slot-scope="scope">
                <el-input v-model="scope.row.first_rebate"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="second_rebate" label="第二单/%">
            <template slot-scope="scope">
                <el-input v-model="scope.row.second_rebate"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="three_rebate" label="第三单/%">
            <template slot-scope="scope">
                <el-input v-model="scope.row.three_rebate"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="four_rebate" label="第四单/%">
            <template slot-scope="scope">
                <el-input v-model="scope.row.four_rebate"></el-input>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>

      <el-form-item :label-width="formLabelWidth" label="第四单返利物品">
        <!-- <RelationNumProduct :form="form" ></RelationNumProduct> -->
        <div @click="choose" v-if="form.coupon[0].coupon_id==''">选择优惠券</div>
        <div v-if="form.coupon[0].coupon_id" style="display: block;">
          <div  @click="choose" >优惠券：<span style="color: #72aeef;">{{ form.coupon[0].coupon_name }}</span> </div>
          <div style="display: block;" >
           赠送数量： <el-input style="width: 150px;" placeholder="请填写赠送数量 " v-model="form.coupon[0].coupon_num"></el-input>
          </div>
        </div>
        <GetCoupon v-if="isCoupon" :open_add="isCoupon" @closeDialog="closeProductDialogFunc($event)">选择优惠券弹出层</GetCoupon>

      </el-form-item>

    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="addGrade()" :disabled="submit_loading">确 定</el-button>
    </div>

  
  </el-dialog>
    
    <Product :isproduct="isproduct" @closeDialog="closeDialogFunc($event)">产品列表弹出层</Product>
   </div>
</template>

<script>
  import Product from '@/components/product/Product';
  import LooprebateApi from '@/api/looprebate.js';
  import RelationProduct from './Relationproduct';
  import RelationNumProduct from './RelationNumProduct';
  import GetCoupon from '@/components/coupon/GetCoupon';
  export default {
    components: {

      RelationProduct,
      /*产品列表组件*/
      Product:Product,
      RelationNumProduct,
      GetCoupon
    },
    data() {
      return {
        form: {
          status:1,
          upgrade_goods_id:[],
          product:[],
          coupon:[{
            coupon_id:""
          }],//选择的返利物品
   
        },

        formLabelWidth: '120px',
        /*是否显示*/
        dialogVisible: false,
        /*是否正在提交*/
        submit_loading: false,

        content:'',//备注
        isproduct:0,
        isCoupon:false,

      };
    },
    props: ['open_add',"gradeList"],
    created() {
      this.dialogVisible = this.open_add;
      console.log("this.gradeList",this.gradeList)
    },
    methods: {
      choose(){
        this.isCoupon = true;
      },
      /*添加等级*/
      addGrade() {
        let self = this;
        let params = this.form;
        params.gradeList =JSON.stringify(this.gradeList);
        params.coupon =JSON.stringify(this.form.coupon);
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.submit_loading = true;
            LooprebateApi.addLooprebate(params, true).then(data => {
                self.submit_loading = false;
                self.$message({
                  message: data.msg,
                  type: 'success'
                });
                self.dialogFormVisible(true);
              })
              .catch(error => {
                self.submit_loading = false;
              });
          }
        });
      },

      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },

       /*产品列表弹出层*/
      openProduct() {
        this.isproduct = true;
      },
            /*关闭弹窗*/
    closeProductDialogFunc(e) {
      console.log("e",e)
      this.isCoupon = false;
      this.form.coupon = [{
        coupon_id:e.params.coupon_id,
        coupon_name:e.params.name,
      }]

 },
      /*关闭弹窗*/
      closeDialogFunc(e) {
        this.isproduct = e.openDialog;
        console.log("success",e);
        if (e.type == 'success') {
          if (this.form.upgrade_goods_id.indexOf(e.params.product_sku_id) == -1) {
            this.form.upgrade_goods_id.push(e.params.product_sku_id);
            this.form.product = { 
              product_sku_id:e.params.product_sku_id,
               product_id: e.params.product_id,
                product_image: e.params.product_image,
                product_name: e.params.product_name 
            };
          } else {
            this.$message({
              message: '已选择该商品',
              type: 'warning'
            });
          }
        
          
        }
      },
      /*删除商品*/
      deleteFunc(i) {
        this.form.upgrade_goods_id.splice(i, 1);
        this.form.product.splice(i, 1);
      },
    }
  };
</script>

<style scoped="scoped">
.img {
  width: 100px;
  margin-top: 10px;
  height: 130px;
  margin-right: 10px;
}

.img img {
  border: 1px solid #eeeeee;
}

.delete-btn {
  position: absolute;
  display: block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  right: -8px;
  top: -8px;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/looprebate/index/add.vue